module.exports = __webpack_public_path__ + "static/media/reason_01.1d19dca4.woff";